import styled, { keyframes } from 'styled-components';

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  animation: ${rotate360} 2s linear infinite;
  width: 24px;
  height: 24px;
  border-radius: 50%;
`;

export function LoadingIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4140_88322)">
        <path d="M12 1V5" stroke="#2E2E2E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path opacity="0.9" d="M19.778 4.22217L16.95 7.05017" stroke="#2E2E2E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path opacity="0.8" d="M23 12H19" stroke="#2E2E2E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path opacity="0.7" d="M19.778 19.7782L16.95 16.9502" stroke="#2E2E2E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path opacity="0.6" d="M12 23V19" stroke="#2E2E2E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path opacity="0.5" d="M4.22192 19.7782L7.04992 16.9502" stroke="#2E2E2E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path opacity="0.4" d="M1 12H5" stroke="#2E2E2E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path opacity="0.3" d="M4.22192 4.22217L7.04992 7.05017" stroke="#2E2E2E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_4140_88322">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function LoadingSpinner() {
  return <Spinner><LoadingIcon /></Spinner>;
}
